export default "__VITE_ASSET__BGJQyVtS__"